module.exports = __webpack_public_path__ + "img/almanac_plus_logo_black.ee70a2cf.svg";